(function() {
    angular
        .module('rlt')
        .controller('SetResponseTypeCtrl', SetResponseTypeCtrl );

    SetResponseTypeCtrl.$inject = [
        'DataDrivenDialogService'
    ];

    function SetResponseTypeCtrl( DataDrivenDialogService ) {

        var vm = this;
        vm.typeDialog = DataDrivenDialogService.register('SetResponseType');
        vm.onSubmit = onSubmit;
        vm.onCancel = onCancel;

        function onSubmit() {
            DataDrivenDialogService.onSubmit('SetResponseType');
        }

        function onCancel() {
            DataDrivenDialogService.onCancel('SetResponseType');
        }
    }
})();
